import XLSX from 'xlsx';

function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data) {
  var ws = {};
  var range = {
    s: {
      c: 10000000,
      r: 10000000,
    },
    e: {
      c: 0,
      r: 0,
    },
  };
  for (var R = 0; R !== data.length; ++R) {
    for (var C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = {
        v: data[R][C],
      };
      if (cell.v == null) continue;
      var cell_ref = XLSX.utils.encode_cell({
        c: C,
        r: R,
      });

      if (typeof cell.v === 'number') cell.t = 'n';
      else if (typeof cell.v === 'boolean') cell.t = 'b';
      else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = XLSX.SSF._table[14];
        cell.v = datenum(cell.v);
      } else cell.t = 's';

      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
  return ws;
}

function getLabel(key) {
  const index = key.indexOf(']');
  return index === -1 ? key : key.substring(index + 1);
}

function createSheetData(data) {
  const columns = Object.keys(data[0]);
  const sheetData = [columns.map((key) => getLabel(key))];

  data.forEach((row) => {
    const sheetRow = [];
    columns.forEach((column) => {
      const value = row[column];
      sheetRow.push(value || '');
    });
    sheetData.push(sheetRow);
  });

  return sheetData;
}

export function getWorkbookData(data) {
  const wb = {
    SheetNames: data.map((sheet) => sheet.name),
    Sheets: {},
  };

  data.forEach((sheet) => {
    wb.Sheets[sheet.name] = sheet_from_array_of_arrays(
      createSheetData(sheet.data)
    );
  });

  return XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'base64',
  });
}

export function getWorkbookTempData(data) {
  const wb = sheet_from_array_of_arrays(createSheetData(data));
  return XLSX.utils.sheet_to_html(wb);
}



// WEBPACK FOOTER //
// src/utils/Workbook.js